import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@type/index';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.eat || initialState;

export const selectIsLoading = createSelector(
  [selectDomain],
  state => state.loading,
);

export const selectIsError = createSelector(
  [selectDomain],
  state => state.error,
);

export const selectIsSuccess = createSelector(
  [selectDomain],
  state => state.success,
);

export const selectEat = createSelector(
  [selectDomain],
  state => state.eat || undefined,
);

export const selectCategory = createSelector(
  [selectDomain],
  state => state.category || undefined,
);
export const selectBannerEat = createSelector(
  [selectDomain],
  state => state.banner || undefined,
);
